export enum ACCOUNT_TYPE {
  CONTA_CORRENTE_PESSOA_FISICA = 1,
  CONTA_CORRENTE_PESSOA_JURIDICA = 2,
  CONTA_POUPANCA_PESSOA_FISICA = 3,
  CARTAO_MAGNETICO = 4,
  CONTA_PAGAMENTO_PESSOA_FISICA = 5,
}

export enum ATTACHMENT_TYPE {
  CCB = 1,
  DOCUMENTO_FRENTE = 2,
  DOCUMENTO_VERSO = 3,
  SELFIE = 4,
  FOTO_PROVA_DE_VIDA = 5,
  COMPROVANTE_DE_ENDERECO = 6,
  COMPROVANTE_FINANCEIRO = 7,
  CNH = 8,
  REPASSE = 11,
  DOCUMENTOS_ADICIONAIS = 12,
  FRENTE_CNH = 13,
  VERSO_CNH = 14,
  TERMO_E_ASSINATURAS = 15,
  CONTRACHEQUE = 16,
  DOCUMENTO_ASSINADO_FISICAMENTE = 17,
  DOCUMENTO_FRENTE_ROGADO = 18,
  DOCUMENTO_VERSO_ROGADO = 19,
  CNH_ROGADO = 20,
  DOCUMENTO_FRENTE_TESTEMUNHA_1 = 9,
  DOCUMENTO_VERSO_TESTEMUNHA_1 = 10,
  CNH_TESTEMUNHA_1 = 21,
  DOCUMENTO_FRENTE_TESTEMUNHA_2 = 23,
  DOCUMENTO_VERSO_TESTEMUNHA_2 = 24,
  CNH_TESTEMUNHA_2 = 25,
  ARQUIVO_RETORNO_RESERVA = 22,
  DOCUMENTO_FRENTE_REPRESENTANTE_LEGAL = 28,
  DOCUMENTO_VERSO_REPRESENTANTE_LEGAL = 29,
  CNH_REPRESENTANTE_LEGAL = 30,
  SELFIE_REFORMALIZACAO = 31,
  BOLETO = 35,
  COMPROVANTE_PAGAMENTO = 36,
}

export enum ATTACHMENT_SUBTYPE {
  TERMO_CCB = 1,
  TERMO_ADESAO = 2,
  TERMO_CONSENTIMENTO = 3,
  TERMO_AUTORIZACAO_INSS = 4,
  TERMO_SEGURO_PRATA = 5,
  TERMO_SEGURO_OURO = 6,
  TERMO_SEGURO_DIAMANTE = 7,
  TERMO_REGULAMENTO = 8,
  TERMO_SEGURO_SUPER_DIAMANTE = 9,
  TERMO_RECONHECIMENTO_DIVIDA = 10,
  TERMO_SUPERENDIVIDAMENTO = 11,
}

export enum CONTRACT_STATUS {
  DIGITACAO = 1,
  AGUARDANDO_FORMALIZACAO = 2,
  FORMALIZADO = 3,
  MESA = 4,
  EM_AVERBACAO = 5,
  PAGO = 6,
  CANCELADO = 0,
}

export enum CONTRACT_TYPE {
  OPERACAO_NOVA = 1,
}

export enum CORBAN_ACTION {
  APROVAR = 1,
  RECUSAR = 2,
  PENDENCIAR = 3,
}

export enum DOCUMENT_TYPE {
  RG = 1,
  CNH = 2,
  OUTROS = 3,
}

export enum PRODUCT_CODE {
  CARTAO_BENEFICIO = "001",
  SAQUE_COMPLEMENTAR = "003",
  CARTAO_CONSIGNADO = "005",
  REFIN_SAQUE_CARTAO = "009",
  AGREGACAO_MARGEM_CARTAO = "010",
  CONSIGNADO_PRIVADO = "023",
  CONSIGNADO_PUBLICO = "024",
  COMPRA_CLIENTE_BENEFICIO = "025",
  COMPRA_CLIENTE_CONSIGNADO = "026",
  SEGUROS = "028",
}

export enum PRODUCT_STATUS {
  // CARTAO_BENEFICIO
  ANDAMENTO_SIMULACAO = 1,
  ANDAMENTO_FORMALIZACAO = 5,
  APROVADA_FINALIZADA = 6,
  REPROVADA_FINALIZADA = 7,
  CHECAGEM_MESA_FORMALIZACAO = 8,
  APROVADA_MESA_FORMALIZACAO = 9,
  REPROVADA_MESA_FORMALIZACAO = 10,
  PENDENTE_DOCUMENTACAO = 11,
  EM_AVERBACAO = 12,
  APROVADA_AVERBACAO = 13,
  RECUSADA_AVERBACAO = 14,
  ANDAMENTO_EMISSAO_CARTAO = 15,
  FINALIZADA_EMISSAO_CARTAO = 16,
  ANDAMENTO_LIBERACAO_SAQUE = 17,
  FINALIZADA_LIBERACAO_SAQUE = 18,
  PENDENTE_CORRECAO_DADOS_BANCARIOS = 19,

  // PORTABILIDADE
  AGUARDA_ENVIO_LINK = 20,
  FORMALIZACAO_CLIENTE = 21,
  TEIMOSINHA_COMPRA_CLIENTE = 22,
  PENDENTE_DADOS_DIVERGENTES = 23,
  REPROVADA_POLITICA_INTERNA = 24,
  CHECAGEM_MESA_CORBAN = 25,
  PENDENTE_DOCUMENTACAO_MESA_CORBAN = 26,
  REPROVADA_MESA_CORBAN = 27,
  APROVADA_MESA_CORBAN = 28,
  CHECAGEM_MESA_DE_FORMALIZACAO = 29,
  APROVADA_MESA_DE_FORMALIZACAO = 30,
  REPROVADA_MESA_DE_FORMALIZACAO = 31,
  MESA_DE_ELEGIBILIDADE = 32,
  INT_CONFIRMA_PAGAMENTO = 34,
  SALDO_REPROVADO = 35,
  REPROVADA_PAGAMENTO_DEVOLVIDO = 36,
  INT_AGUARDA_AVERBACAO = 37,
  INT_FINALIZADO = 38,
  INT_AVERBACAO_PENDENTE = 39,

  // CARTAO NOVOS
  ERRO_SOLICITACAO_SAQUE = 40,

  // PORTABILIDADE IN100
  REPROVADO = 41,
  AGUARDANDO_RETORNO_IN100 = 42,

  // NOVO STATUS
  AGUARDANDO_IN100_RECALCULO = 43,
  RETORNO_IN100_RECALCULO_RECEBIDO = 44,

  REVISAO_MESA_DE_FORMALIZACAO = 45,
  REPROVADA_REVISAO_MESA_DE_FORMALIZACAO = 46,
  AVERBACAO_MESA_DE_FORMALIZACAO = 47,

  SAQUE_CANCELADO_LIMITE_DISPONIVEL_INSUFICIENTE = 48,
  SAQUE_RECUSADO_PROBLEMA_PAGAMENTO = 49,

  ANDAMENTO_REAPRESENTACAO_DO_PAGAMENTO_DE_SAQUE = 50,
  PENDENCIADO = 51,

  ANDAMENTO_CHECAGEM_DATAPREV = 52,
  ERRO_CONSULTA_DATAPREV = 53,
  REPROVADO_CONSULTA_DATAPREV = 54,
  AGUARDANDO_AVERBACAO_REFIN = 55,

  // PORT + REFIN
  AGUARDANDO_DESEMBOLSO_REFIN = 56,
  INT_FINALIZADO_DO_REFIN = 58,

  ERRO_CRIACAO_CARTAO = 59,
  PENDENTE_APROVACAO_RECALCULO_CORBAN = 60,

  CHECAGEM_MESA_DE_AVERBECAO = 61,

  AGUARDA_FINALIZACAO_PROPOSTA_PRINCIPAL = 62,
  REPROVADA_MESA_DE_AVERBECAO = 63,
  INT_AJUSTE_AVERBACAO = 64,

  VALIDACOES_AUTOMATICAS = 65,
  AGUARDANDO_DESEMBOLSO = 66,
  INT_AGUARDANDO_PAGO_QITECH = 67,

  PENDENCIAS_AVERBACAO_CORBAN = 68,
  REGULARIZADA_MESA_AVERBACAO = 69,
  FINALIZADA_FORMALIZACAO_CLIENTE = 70,
  FINALIZADA_FORMALIZACAO_ROGADO = 71,

  AGUARDANDO_FIM_MACICA = 72,
  CHECAGEM_MESA_VIDEO = 73,

  TEIMOSINHA_DATAPREV = 74,

  UPDATE_LIMIT_IN_PROGRESS = 77,
  UPDATE_LIMIT_FINISHED = 78,
  UPDATE_LIMIT_ERROR = 79,

  APROVADA_VIDEO_CHAMADA = 85,
  REPROVADO_VIDEO_CHAMADA = 75,
  PENDENCIADO_VIDEO_CHAMADA = 76,

  CHECAGEM_AVERBACAO_CONECTA = 80,
  APROVADA_AVERBACAO_CONECTA = 81,
  PENDENCIADO_AVERBACAO_CONECTA = 82,
  REGULARIZADA_AVERBACAO_CONECTA = 83,
  REPROVADO_AVERBACAO_CONECTA = 84,
  TEIMOSINHA_IN100 = 86,
  APROVADO_PRICING = 88,
  RECALCULO_PRICING = 89,

  // REFORMALIZAÇÃO
  REFORMALIZACAO_CLIENTE = 91,
  PROPOSTA_CANCELADA_PELO_CORBAN = 92,
  APROVADO_REFORMALIZACAO = 93,
  APROVADO_AUTOMATICAMENTE_MESA_FORMALIZACAO = 94,

  TAXA_COMISSAO_COBYX_REALIZADA = 95,
  ERRO_TAXA_COMISSAO_COBYX = 96,
  CHECAGEM_MESA_SALDO = 97,
  RECUSADA_AVERBACAO_SIAPE = 98,
  RECUSADA_AVERBACAO_CLIENTE = 99,
  AGUARDANDO_ACEITE_CLIENTE_AVERBACAO = 100,

  // CANCELAMENTO DE PROPOSTA
  CANCELADO = 101,
  ANDAMENTO_ANALISE_OPERACIONAL = 102,

  ANALISE_TECNICA = 103,
  PENDENTE_VALIDACAO_PARCELA = 104,
  PARCELA_AJUSTADA = 105,
  FINALIZADO_LIQUIDACAO_SAQUE = 106,
  PROPOSTA_REPRESADA = 107,

  ANDAMENTO_CONSULTA_SALDO_DEVEDOR_SAQUE = 108,
  ANDAMENTO_QUITECAO_SALDO_DEVEDOR_SAQUE = 109,
  ANDAMENTO_SOLICITACAO_SAQUE_REFIN = 110,
  FINALIZADA_LIQUIDADO_SAQUE = 111,
  REPROVADO_RECALCULO_REFIN_SAQUE = 112,

  // AGREGACAO DE MARGEM CARTAO
  EM_ANDAMENTO_ALTERACAO_LIMITE = 113,
  FINALIZADO_ALTERACAO_LIMITE = 114,
  REPROVADO_ALTERACAO_LIMITE = 115,
  INICIO_VALIDACAO_AUTOMATICA = 116,
  FIM_VALIDACAO_AUTOMATICA = 117,

  // COMPRA DE CLIENTE
  LIBERACAO_QUITACAO_CORBAN = 33,
  QUITACAO_EFETIVADA = 118,
  LIBERADO_QUITACAO_CORBAN = 119,
  LIBERADO_QUITACAO_AMIGOZ = 120,

  // RECALCULO CARTAO
  RECALCULO_LIMITE_FORMALIZACAO_CLIENTE = 121,

  SALDO_REPROVADO_RECALCULO = 122,
  AGUARDANDO_LIBERACAO_MARGEM_CORBAN = 123,

  PENDENTE_MESA_ELEGIBILIDADE = 124, // - Pendente Mesa de Elegibilidade - Compra de Cliente
  REGULARIZADA_MESA_ELEGIBILIDADE = 125, // - Regularizada - Mesa de Elegibilidade - Compra de Cliente
  // PENDENCIA SERVIDOR
  PENDENCIA_SERVIDOR = 126,
  ANUENCIA_SERVIDOR = 127,
  REPROVADA_AVERBACAO_PARCIAL = 128, //  COMPRA DE CLIENTE — AVERBAÇÃO PARCIAL
  SALDO_RESIDUAL = 129, // SALDO RESIDUAL - Compra de Cliente

  // REENQUADRAMENTO
  BOLETOS_QUITADOS_PROPOSTA_ANTERIOR = 130,
  CANCELADO_NAO_AVERBADO_COMPRA_CLIENTE = 131,
  PROPOSTA_REENQUADRADA = 132,
  ANALISE_DESCONTO_CORBAN = 133,
}

export enum PRODUCT_TYPE {
  TODOS_PRODUTOS = 0,
  FGTS = 1,
  INSS_REPRESENTANTE_LEGAL = 2,
  CARTAO_BENEFICIO_REPRESENTANTE = 3,
  PAB = 4,
  INSS_CORBAN = 5,
  INSS = 6,
  CARTAO_BENEFICIO = 7,
  SIAPE = 8,
  EXERCITO = 9,
  MARINHA = 10,
  AERONAUTICA = 11,
  CONSIGNADO = 13,
  SAQUE_COMPLEMENTAR = 14,
  CARTAO_CONSIGNADO = 15,
  REFIN_CARTAO = 21,
  AGREGACAO_MARGEM = 22,
  // Consignado privado e publico irão ter o mesmo tipo
  CONSIGNADO_PRIVADO = 24,
  COMPRA_CLIENTE_BENEFICIO = 26,
  COMPRA_CLIENTE_CONSIGNADO = 25,
  CONSIGNADO_PUBLICO = 27,

  SEGUROS = 28,
}

export enum BENEFIT_CARD_WITHDRAWAL_TYPE {
  SEM_SAQUE = 0,
  A_VISTA = 1,
  PARCELADO = 2,
}

export enum REPURCHASE_DEBT_WITHDRAWAL_TYPE {
  SEM_SAQUE = 0,
  PARCELADO = 2,
}

export enum BENEFIT_CARD_AUTORIZATION_TYPE {
  AUTOATENDIMENTO = 1,
  AGENCIA = 2,
  DIGITAL_VIA_CLIENTE = 3,
  DIGITAL_VIA_CORRESPONDENTE = 4,
  MOBILE = 5,
}

export enum BENEFIT_CARD_IN100_TYPE_ACCOUNT {
  CONTA_CORRENTE = 2,
}

export enum CONTRACTS_REPORT_TYPE {
  GERAL = "geral",
  DIGITACAO = "digitacao",
  FINALIZACAO = "finalizacao",
}

/**
 * 1 - Ativo, 2 - Pendente, 3 - Recusado, 4 - Cancelado
 */
export enum INSURANCE_STATUS {
  ATIVO = 1,
  PENDENTE = 2,
  RECUSADO = 3,
  CANCELADO = 4,
}

export enum INSURANCE_TYPE {
  CONTRATACAO = 1,
  RENOVACAO = 2,
}

export enum INSURANCE_CHARGE_TYPE {
  ANUAL = 1,
  MENSAL = 2,
  GRATUITO = 3,
}

export enum INSURANCE_PAYMENT {
  A_VISTA = 1,
  PARCELADO = 2,
  GRATUITO = 3,
}

export enum PLANS_TYPE {
  PRATA = 1,
  OURO = 2,
  DIAMANTE = 3,
  SUPER_DIAMANTE = 4,
  AMIGOZ_MED = 5,
  AMIGOZ_MED_PET = 6,
}

export enum MARGIN_TYPE {
  MARGEM_COMPRA = 1,
  MARGEM_SAQUE = 2,
  MARGEM_UNICA = 3,
  MARGEM_UNIFICADA = 4,
}

export enum MANDATORY_COURSE_STATUS {
  PENDENTE = "PENDENTE",
  EM_ANDAMENTO = "EM_ANDAMENTO",
  FINALIZADO = "FINALIZADO",
}

export enum AVERBADORAS {
  FACIL = 1,
  ZETRASOFT = 2,
  QUANTUM = 3,
  DATAPREV_BRB = 4,
  DATAPREV_PINE = 5,
  SERPRO = 6,
  NEOCONSIG = 7,
}

export enum HIERARCHY_LEVEL {
  ADMINISTRADOR = 5,
  DONO_LOJA = 4,
  GERENTE = 3,
  SUPERVISOR = 2,
  DIGITADOR = 1,
}

export enum REGISTRATION_PENDENCY_TYPE {
  SENHA_DE_AVERBACAO = 1,
  CONTRACHEQUE = 2,
  DEMAIS_ANEXOS_DE_AVERBACAO = 3,
}

export enum EDUCATION_LEVEL {
  FUNDAMENTAL = 1,
  MEDIO = 2,
  SUPERIOR = 3,
  POS_GRADUADO = 4,
  ANALFABETO = 5,
}

export enum KINSHIP_LEVEL {
  PAI = 1,
  MAE = 2,
  FILHO = 3,
  CONJUGE = 4,
  IRMAO = 5,
}

export enum CALL_LOG_TYPE {
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
  STARTED_RECORD = "started_record",
  FINALIZED_BY_ATTENDANT = "finalized_by_attendant",
}

export enum CHANNELS {
  WEBSITE = "Website",
}

export enum SIAPE_BOND_TYPE {
  SERVIDOR = 1,
  PENSIONISTA = 2,
}

export enum RETENTION_STATUS {
  SEM_RETENCAO = 0,
  RETENCAO_RECEBIDA = 1,
  RETENCAO_ENVIADA = 2,
}

export enum REASON_CONTRACT_CANCELATION {
  DESISTENCIA_CLIENTE = 1,
  FORMALIZACAO_EXPIRADA = 2,
  SALDO_RESIDUAL = 6,
}

export enum STATUS_EMPLOYER {
  GERADO = 0,
  ENVIADO = 1,
  ACEITO = 2,
}

export enum TREADMILL {
  AGUARDANDO_ACEITE = 0,
  SOLICITACAO_ENVIADA = 1,
  SOLICITACAO_RECUSADA = 2,
  OFERTA_ENVIADA = 3,
  FORMALIZACAO = 4,
  AGUARDANDO_DESENBOLSO = 5,
  FINALIZADO = 6,
}

export enum USER_GROUP {
  MESA_CORBAN = 1,
  CORRESPONDENTE = 2,
  CONSULTOR = 3,
}

export enum USER_STATUS {
  EM_VALIDACAO = 1,
  APROVADO = 2,
  REPROVADO = 3,
}

export enum FEE_TYPE {
  EMISSAO_CARTAO = 1,
}

export enum SERVICES_TYPES {
  AMIGOZ = PRODUCT_CODE.CARTAO_BENEFICIO,
  AGREGACAO_MARGEM = PRODUCT_CODE.AGREGACAO_MARGEM_CARTAO,
  CONSIGNADO_PRIVADO = PRODUCT_CODE.CONSIGNADO_PRIVADO,
  CONSIGNADO_PUBLICO = PRODUCT_CODE.CONSIGNADO_PUBLICO,
  COMPRA_CLIENTE_BENEFICIO = PRODUCT_CODE.COMPRA_CLIENTE_BENEFICIO,
  COMPRA_CLIENTE_CONSIGNADO = PRODUCT_CODE.COMPRA_CLIENTE_CONSIGNADO,
  SEGUROS = PRODUCT_CODE.SEGUROS,
}

export enum INSURANCE_ATTACHMENT_TYPE {
  DOCUMENTO_FRENTE = 1,
  DOCUMENTO_VERSO = 2,
  CNH = 3,
  TERMOS_E_ASSINATURAS = 4,
  SELFIE = 5,
}

export enum REFRAME_REPURCHASE_STATUS {
  /** scenario 1 */
  SEM_TROCO = "SEM_TROCO",
  /** scenario 2 */
  TROCO_ABAIXO_MINIMO = "TROCO_ABAIXO_MINIMO",
  /** scenario 3 */
  TROCO_ELEGIVEL = "TROCO_ELEGIVEL",
  /** scenario 4 */
  MARGEM_INSUFICIENTE = "MARGEM_INSUFICIENTE",
}
